import { useEffect, useState } from 'react';
import {
  getOneLiveChatStatus,
  subscribeOneLiveChatStatus,
} from '@belong/integrations-belong-one-chat/utils';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

const ONE_LIVE_CHAT_FLAG = 'belong-one-live-chat';

type SupportChatProvider = 'one' | 'intercom';

let latchedProvider: SupportChatProvider | null = null;

function latchProvider(provider: SupportChatProvider | null) {
  latchedProvider ??= provider;

  return latchedProvider;
}

export function useSupportChatProvider(): SupportChatProvider | null {
  const { treatments, isReady, hasTimedout } = useSplitTreatments({
    names: [ONE_LIVE_CHAT_FLAG],
  });

  if (isReady || hasTimedout) {
    return latchProvider(
      treatments[ONE_LIVE_CHAT_FLAG]?.treatment === 'on' ? 'one' : null,
    );
  }

  return latchedProvider;
}

export function useOneLiveChatStatus() {
  const [status, setStatus] = useState(getOneLiveChatStatus);

  useEffect(() => {
    setStatus(getOneLiveChatStatus());

    return subscribeOneLiveChatStatus(() => setStatus(getOneLiveChatStatus()));
  }, []);

  return status;
}
